import { render, staticRenderFns } from "./VerifyCustomerControl.vue?vue&type=template&id=1d8c1eac&scoped=true"
import script from "./VerifyCustomerControl.vue?vue&type=script&lang=js"
export * from "./VerifyCustomerControl.vue?vue&type=script&lang=js"
import "./VerifyCustomerControl.vue?vue&type=style&index=0&id=1d8c1eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c1eac",
  null
  
)

export default component.exports